import React, { useState, useEffect } from "react";
import { Col, Image, Button, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import {
  superadmin_vendor_Single_open_issue,
  comment_super_admin_open_issues,
} from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import isEmpty from "../../../../../store/validation/is-Empty";
import { AdminViewIssuesRight } from "./AdminViewIssuesRight";
import { AdminViewIssues } from "./AdminViewIssues";

const SuperAdminViewVendorsTickets = (props) => {
  //state
  const [showChat, setShowChat] = useState(false);
  const [showLog, setShowLog] = useState(true);
  const handleChatSHow = () => {
    setShowChat(true);
    setShowLog(false);
  };
  const handleLogSHow = () => {
    setShowLog(true);
    setShowChat(false);
  };

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [issuesDetails, setIssuesDetails] = useState({});
  useEffect(() => {
    let issueId = location.state.issuesId;
    let token = props.auth.user.accessToken;
    dispatch(superadmin_vendor_Single_open_issue(issueId, token));
  }, [location]);

  useEffect(() => {
    setIssuesDetails(props.singleIssues);
  }, [props.singleIssues]);

  const [message, setNewMessage] = useState({ message: "" });

  const onClickAddComment = () => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.respond = message.message;
    dispatch(
      comment_super_admin_open_issues(
        formData,
        token,
        issuesDetails._id,
        clearMessage
      )
    );
  };

  const clearMessage = (e) => {
    setNewMessage({
      message: "",
    });
    let issuesId = issuesDetails._id;
    const token = props.auth.user.accessToken;
    dispatch(superadmin_vendor_Single_open_issue(issuesId, token));
    setNewMessage({
      message: "",
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Col className="d-flex flex-wrap pb-3">
              <Col md={6} className="pt-4">
                <NavLink to="/openissuesvendors" className="f12-500 enBackLink">
                  <Image
                    fluid
                    alt="Back Icon"
                    title="Back Icon"
                    className="mr-2"
                    src={require("../../../../../assets/images/UserManagement/backIcon.svg")}
                  />
                  Back
                </NavLink>
                <div className="f24_700_HelveticaNeue">
                  Issue No : {issuesDetails && issuesDetails.issue_id}
                </div>
              </Col>
              <Col
                md={6}
                className="d-flex align-items-end justify-content-end"
              >
                {showLog && (
                  <Button
                    variant="danger"
                    className="btn2 btn-lg"
                    onClick={handleChatSHow}
                  >
                    Submit Response
                  </Button>
                )}
                {showChat && (
                  <Button
                    variant="danger"
                    className="btn2 btn-lg"
                    onClick={handleLogSHow}
                  >
                    View Log
                  </Button>
                )}
              </Col>
            </Col>
            <div className="super-admin-inside-right-side-panel pt-4 pb-4">
              <div className="row">
                <div className="col-lg-5 pr-lg-0">
                  <AdminViewIssues
                    issuesData={issuesDetails && issuesDetails}
                    token={props.auth.user.accessToken}
                  />
                </div>
                <div className="col-lg-7 pl-lg-2">
                  <AdminViewIssuesRight
                    message={message.message}
                    onChange={(e) =>
                      setNewMessage({
                        [e.target.name]: e.target.value,
                      })
                    }
                    onClickAddComment={(e) =>
                      onClickAddComment(message.message)
                    }
                    auth={props.auth}
                    logData={issuesDetails}
                    showLog={showLog}
                    showChat={showChat}
                    onClickShowLog={handleLogSHow}
                    handleChatSHow={handleChatSHow}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

SuperAdminViewVendorsTickets.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  singleIssues: state.adminAllVendorsInfo.superAdminSingleOpenIssuesVendor,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_vendor_Single_open_issue,
  comment_super_admin_open_issues,
})(withRouter(SuperAdminViewVendorsTickets));
